import { useContext } from "react";
import { AnalyticsContext } from "../core/AnalyticsContext";
import type { BaseEvent } from "../core/BaseEvent";

export const useTrack = <
  TEvent extends BaseEvent<object> = BaseEvent<object>,
>() => {
  const analytics = useContext(AnalyticsContext);
  return (event: TEvent) => {
    analytics.track(event);
  };
};
